import { DiscountType } from "../interfaces/enums/DiscountType";
import IBenefitDiscount from "../interfaces/IBenefitDiscount";
import IQuoteCardResult from "../../compare/interfaces/results/IQuoteCardResult";
import ProductType from "../interfaces/enums/ProductType";

type DiscountListType = {
    title: string;
    value: number;
};

type DiscountGroupingType = {
    [key in DiscountType]?: {
        [percentage: number]: number;
    };
};
/**
 * TODO: This is not appropriately named anymore and could be removed
 *
 */
type UseCartType = {
    getGroupedDiscounts: (list: IBenefitDiscount[]) => DiscountListType[];
    generateApplicationURL: (groupId: string, card: IQuoteCardResult) => string;
};

const useCart = (): UseCartType => {
    const getPercentageString = (percentage: number): string => {
        const num = (percentage * 100).toFixed(2).toString(); // Get to 2dp
        const finalNumber = num.replace(/\.0*$/, "");
        return `${finalNumber}%`;
    };

    const getDiscountTitle = (type: DiscountType): string => {
        switch (type) {
            case DiscountType.MultiPolicy:
                return "Multi-policy discount";
            case DiscountType.AdditionalChildren:
                return "Additional Children";
            case DiscountType.GeneralProduct:
                return "LifeDirect nib Health Discount";
            default:
                return "Discount";
        }
    };

    const getGroupedDiscounts = (list: IBenefitDiscount[]): DiscountListType[] => {
        const discountGrouping: DiscountGroupingType = {};

        list.forEach((discount) => {
            const currentSum =
                discountGrouping[discount.type]?.[discount.percentage] || 0;

            discountGrouping[discount.type] = {
                ...discountGrouping[discount.type],
                [discount.percentage]: currentSum + discount.value
            };
        });

        return Object.entries(discountGrouping)
            .map(([key, value]): DiscountListType[] => {
                const type = parseInt(key) as DiscountType;

                return (
                    Object.entries(value).map(
                        ([percentage, sum]): DiscountListType => {
                            return {
                                title: `${getDiscountTitle(type)} (${getPercentageString(
                                    parseFloat(percentage)
                                )})`,
                                value: sum
                            };
                        }
                    ) || []
                );
            })
            .reduce((a, b) => b.concat(a), []);
    };

    const getApplicationURL = (
        groupId: string,
        providerId: number,
        applicationSource: number,
        caseProduct: { baseProductId: number; caseId: number }[]
    ): string => {
        const externalAppFormSource: number = 2; 
        if (applicationSource === externalAppFormSource) {
            return `/compare/app-form?providerId=${providerId}&groupId=${groupId}&caseProduct=${caseProduct
                .map((product) => `${product.caseId}:${product.baseProductId}`)
                .join(",")}`;
        }
        return `/compare/apply/form?groupId=${groupId}&providerId=${providerId}&caseProduct=${caseProduct
            .map((product) => `${product.caseId}:${product.baseProductId}`)
            .join(",")}`;
    };

    const generateApplicationURL = (groupId: string, card: IQuoteCardResult): string => {
        const caseProducts = card.result.settings.map((s) => {
            return {
                caseId: s.caseId,
                baseProductId: card.productInfo[s.productType]?.productId || 0
            };
        });

        return getApplicationURL(groupId, card.result.providerId, card.applicationSource, caseProducts);
    };

    return {
        getGroupedDiscounts,
        generateApplicationURL
    };
};

export default useCart;
